import { MYDRA_WORKSPACE_ID_HEADER_NAME } from '@/config/system'
import { PlaybooksService } from '@/services/playbook'
import { useWorkspaceContext } from '@/shared/hooks/useWorkspaceContext'
import {
  ApiErrorResponse,
  ApiIndividualResponse,
  ApiReactMutationOptions,
} from '@/types/api'
import { ApiPlaybookListItem } from '@/types/playbook'
import { useMutation, useQueryClient } from '@tanstack/react-query'

type DuplicatePayload = { fromPlaybookId: string }

export const useDuplicatePlaybook = (
  mutationOptions?: ApiReactMutationOptions<
    ApiIndividualResponse<Pick<ApiPlaybookListItem, '_id'>>,
    DuplicatePayload
  >
) => {
  const queryClient = useQueryClient()
  const { workspaceId } = useWorkspaceContext()

  return useMutation<
    ApiIndividualResponse<Pick<ApiPlaybookListItem, '_id'>>,
    ApiErrorResponse,
    DuplicatePayload
  >({
    ...mutationOptions,
    mutationKey: [
      'playbooks',
      'duplicate',
      ...(workspaceId ? ['workspaceId', workspaceId] : []),
    ],
    mutationFn: async ({ fromPlaybookId }: DuplicatePayload) => {
      return await PlaybooksService.duplicatePlaybook(fromPlaybookId, {
        headers: {
          [MYDRA_WORKSPACE_ID_HEADER_NAME]: workspaceId,
        },
      })
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: ['playbooks'],
        exact: false,
      })
      await mutationOptions?.onSuccess?.(...args)
    },
  })
}
